import HARDCODE from "../../business-const/HardCode/HardCode"

const perfilList = [
   {
      id: HARDCODE.perfilAdministrador,
      descricao: 'Administrador',
      gestorLider: 'S',
      podeInformarDivisaoComissaoSeguroVida: 'S',
      ordem: 10,
   },
   {
      id:  HARDCODE.perfilGestor,
      descricao: 'Gestor',
      gestorLider: 'S',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 20,
   },
   {
      id:  HARDCODE.perfilLider,
      descricao: 'Líder',
      gestorLider: 'S',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 23,
   },
   {
      id:  HARDCODE.perfilBackoffice,
      descricao: 'Backoffice',
      gestorLider: 'N',
      podeInformarDivisaoComissaoSeguroVida: 'S',
      ordem: 26,
   },
   {
      id: HARDCODE.perfilPlanejador,
      descricao: 'Planejador',
      gestorLider: 'N',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 30,
   },
   {
      id: "C",
      descricao: 'Corretor de Seguros',
      gestorLider: 'N',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 40,
   },
   {
      id: "I",
      descricao: 'Assessor de Investimentos',
      gestorLider: 'N',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 50,
   },
   //{
   //   id: HARDCODE.perfilAssessor,
   //   descricao: 'Assessor',
   //   gestorLider: 'N',
   //   podeInformarDivisaoComissaoSeguroVida: 'N',
   //   ordem: 60,
   //},
   {
      id: "N",
      descricao: 'Consórcio',
      gestorLider: 'N',
      podeInformarDivisaoComissaoSeguroVida: 'N',
      ordem: 70,
   },
]
 
export default perfilList